import React, { useMemo } from 'react'
import { Flex, Text } from '@fundamentals'

export const DotSeparator: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const childrenWithDots = useMemo(
    () =>
      React.Children.map(children, (child, index) => {
        if (child && index > 0) {
          return (
            <>
              <Text fontSize='12px'>・</Text>
              {child}
            </>
          )
        }
        return child
      }),
    [children],
  )
  return (
    <Flex gap={0.25} alignItems='baseline' flexWrap='wrap'>
      {childrenWithDots}
    </Flex>
  )
}
